import React from 'react';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';

import PageHeader from 'components/pageHeader';
import UnassignedStudentsTable from 'components/UserDashboardV2/components/UnassignedStudentsTable';
import useResponsive from 'components/UserDashboardV2/hooks/useResponsive';

// Full page for the "unassigned students" link on StudentDistributionCard —
// same full-page-with-sidebar shell as DeviceChangeRequestsPage.
const UnassignedStudentsPage = () => {
    const history = useHistory();
    const location = useLocation();
    const basePath = location.pathname.startsWith('/user-management-v2') ? '/user-management-v2' : '/user-management';
    const { isMobile } = useResponsive();

    const bodyStyle = {
        margin: -20,
        padding: isMobile ? "20px 12px" : "40px 8px 20px 8px",
        width: "calc(100% + 30px)",
        height: "100vh",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
    };

    return (
        <div style={bodyStyle}>
            <PageHeader
                title="Students without courses"
                onBackPress={() => history.push(`${basePath}/students`)}
            />

            <div style={{ margin: "30px 0 0 0", flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
                <UnassignedStudentsTable isMobile={isMobile} />
            </div>
        </div>
    );
};

export default UnassignedStudentsPage;
